import { useFormState } from 'informed';
import { useReduxState } from 'hooks';
import { localeNames } from 'shared-locales';
import {
  CertificatesPreview,
  CertificatesSelectTemplate
} from 'components/admin/settings/certificates';
import {
  Checkbox,
  Emails,
  FormGroup,
  FormSection,
  Select
} from 'components/common/form';

import type { PageState } from 'types';

const PathSettingsCertificates = () => {
  const { messages, pageState, serverConfig } = useReduxState();
  const path: Pick<
    PageState['path'],
    'certificateTemplateId' | 'steps' | 'title'
  > = pageState.path;

  const formState = useFormState();

  const pathContents = path.steps?.map((step, i) => {
    const title =
      (step.items?.[0]?.type === 'course'
        ? step.items[0].course.title
        : step.items?.[0]?.type === 'achievement'
        ? step.items[0].achievement.title
        : step.items?.[0]?.event?.title) || '';
    return { number: step.number, title };
  });

  return (
    <FormSection>
      {serverConfig.certificatesEnableSelection && (
        <CertificatesSelectTemplate maxWidth={200} type="path" />
      )}

      <FormGroup
        label={messages.commonCertificate}
        {...(serverConfig.certificatesEnableSelection
          ? { style: { marginTop: 25 } }
          : {})}
      >
        <CertificatesPreview
          certificateType="path"
          customContent=""
          pathCourses={pathContents}
          templateId={
            (formState.values?.CertificateTemplateId as number) ||
            path.certificateTemplateId ||
            serverConfig.defaultCertificateTemplateId
          }
          title={path.title}
        />
      </FormGroup>

      <Checkbox
        field="certificateAllowDownloading"
        id="certificateAllowDownloading"
        label={messages.settingsCertificateAllowDownloading}
        style={{ marginTop: 20 }}
      />

      <Checkbox
        field="certificateSendToUser"
        id="certificateSendToUser"
        label={messages.settingsCertificateSendToUser}
        style={{ marginTop: 10 }}
      />

      <Checkbox
        field="certificateSendToOtherEmails"
        id="certificateSendToOtherEmails"
        label={messages.settingsCertificateSendToEmails}
        style={{ marginTop: 10 }}
      />

      <Emails
        disabled={!formState.values.certificateSendToOtherEmails}
        field="certificateEmailList"
        id="certificateEmailList"
        style={{ marginLeft: 20, marginTop: 8 }}
      />

      <FormGroup label={messages.settingsCertificateLanguage}>
        <Select
          field="certificateLanguage"
          id="certificateLanguage"
          options={Object.keys(localeNames).map((localeKey) => ({
            label: localeNames[localeKey],
            value: localeKey
          }))}
          style={{ maxWidth: 200 }}
        />
      </FormGroup>
    </FormSection>
  );
};

export default PathSettingsCertificates;
